import CompLayout from "@/pcomponents/comp/layout/layout";
import TodoStuCardListArea from "./area/card_list";
function TodoStuCardListPage() {

  return (
    <CompLayout isConTitle={false}>
      <TodoStuCardListArea></TodoStuCardListArea>
    </CompLayout>
  );
}

export default TodoStuCardListPage;